import { createRoot } from "react-dom/client";

import App from "./App.tsx";

const rootElement = createRoot(document.getElementById("root"));
rootElement.render(<App />);
